import request from '@/utils/seftRequest';

// 查询拆机原因
export function qryDisconnectionReasonBsnl(params) {
  return request('/ding/acctService/qryOrderReasonBsnl', {
    params,
  });
}

// 拆机 drm/ding/subsService/terminationBsnl
export function terminationBsnl(data) {
  return request('/ding/subsService/terminationBsnl', {
    method: 'POST',
    body: data,
  });
}
